import { SxProps, Theme } from '@mui/material';
import { Button } from 'system/atoms';
import { StartCampaign } from 'pages/Campaigns/components/StartCampaign';
import { Paths } from 'services/navigation/paths';
import { useNavigate } from 'react-router-dom';
import { useFlag } from 'services/flags/hooks';
import { Flags } from 'services/flags/constants';

type Props = {
  buttonSx?: SxProps<Theme>;
};

export const StartCampaignFeatureFlag: React.FC<Props> = ({ buttonSx }) => {
  const navigate = useNavigate();
  const isCampaignCreationV3Enabled = useFlag(Flags.CAMPAIGN_CREATION_V3);

  const createCampaign = () => {
    navigate(Paths.CAMPAIGN_CREATE_DRAFT);
  };

  if (isCampaignCreationV3Enabled) {
    return (
      <Button variant="primary" onClick={createCampaign} sx={buttonSx}>
        New campaign
      </Button>
    );
  }

  return <StartCampaign />;
};
